import { WixLogo as WixLogoIcon } from '@wix/vmaf-adi-components/icons';
import React from 'react';

interface IWixLogoProps {
  color: 'white' | 'black';
  [key: string]: any;
}

const WixLogo: React.FC<IWixLogoProps> = ({ color, ...props }) => (
  <WixLogoIcon {...props} style={{ color }} />
);

export default WixLogo;
